import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateTable from 'src/components/ui-component/form-component/create-form/CreateTable';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, GEGENSTAND_DER_FOERDERUNG, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, NonRequired } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung, isTrue } from 'src/utils/helper';
import PruefAssistenz from '../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
let P = Schema.attributes;

const FoerdervoraussetzungenAntragMobilitaetsplaene: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Fördervoraussetzungen' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Pruefstatus.path}
				hinweisPath={
					P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Hinweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
			<CreateTable
				formStruc={formStruc(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
				columnsLabel={COLUMNS_LABEL}
			/>
		</>
	);
};
export default FoerdervoraussetzungenAntragMobilitaetsplaene;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const COLUMNS_LABEL = ['', 'Angabe', { label: 'falls ja: Es handelt sich um', width: '24rem' }];
const formStruc = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					path: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0043825829_Um_Eine_Kumulierte_Beihilfe.path,
					type: 'label',
				},
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0043825829_Um_Eine_Kumulierte_Beihilfe,
					type: 'radio',
					validation: [{ validateFunction: NonRequired }],
				},
				...((
					isTrue(
						get(
							application,
							P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0043825829_Um_Eine_Kumulierte_Beihilfe.path,
							false,
						),
					)
				) ?
					[
						{
							...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0183266045_falls_Ja_Es_Handelt_Sich_Um,
							type: 'multiSelect',
						},
					]
				:	[]),
			],
		},
		{
			fields: [
				{
					path: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0004171572_and_Personalstelle_Beantragt.path,
					type: 'label',
				},
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0004171572_and_Personalstelle_Beantragt,
					type: 'radio',
					validation: [{ validateFunction: NonRequired }],
				},
			],
		},
		...((
			get(
				application,
				P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0195191031_ng_Gegenstand_Der_Foerderung.path,
				'',
			) === GEGENSTAND_DER_FOERDERUNG.Umsetzung
		) ?
			[
				{
					fields: [
						{
							path: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0066875012_Weiteren_Kommunen_Beteiligt
								.path,
							type: 'label',
						},
						{
							...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0066875012_Weiteren_Kommunen_Beteiligt,
							type: 'radio',
							validation: [{ validateFunction: NonRequired }],
						},
					],
				},
			]
		:	[]),
	];
	return struc;
};

export const getFormStrucFoerdervoraussetzungenAntragMobilitaetsplaene = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Pruefstatus.path,
			P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc(application));

	return concat(formStruc(application));
};
